import React from 'react'
import { Outlet, useNavigate, useOutletContext, useLocation } from 'react-router-dom'
import check from '../../../../assets/fashion/Actions/check.svg'
import pdf from '../../../../assets/fashion/Actions/pdf.svg'
import receipt from '../../../../assets/fashion/Actions/receipt.svg'
import money from '../../../../assets/fashion/Actions/money.svg'
import envelope from '../../../../assets/fashion/Actions/envelope.svg'
import whatsapp from '../../../../assets/fashion/Actions/whatsapp.svg'
import view from '../../../../assets/fashion/Actions/view.svg'
import duplicate from '../../../../assets/fashion/Actions/duplicate.svg'
import pencil from '../../../../assets/fashion/Actions/pencil.svg'
import trash from '../../../../assets/fashion/Actions/trash.svg'
import { ActionDiv, ActionLink, ActionText } from './style'


type ActionsProps = {
    orderId: number
    onDelete: () => void
  }
  
  const Actions: React.FC<ActionsProps> = ({ orderId, onDelete }) => {
    const navigate = useNavigate();
  
    const handleDeleteOrder = async (orderId: number) => {
        const confirmDelete = window.confirm("Tem certeza que deseja excluir este pedido?");
        if (!confirmDelete) return;
      
        try {
          const response = await fetch(`${process.env.REACT_APP_FASHION_ORDERS_BASE_URL}/fashion-order/${orderId}`, {
            method: 'DELETE',
          });
      
          if (response.ok) {
            onDelete(); // Remove da tela sem recarregar
            window.alert("Pedido excluído com sucesso!");
          } else {
            console.error('Erro ao excluir o pedido');
          }
        } catch (error) {
          console.error('Erro ao excluir o pedido', error);
        }
    };
  
    const actions = [
      { path: '#', image: check, name: 'Fechar venda' },
      { path: '#', image: pdf, name: 'Gerar PDF' },
      { path: '#', image: receipt, name: 'Faturar' },
      { path: '#', image: money, name: 'Comissão' },
      { path: '#', image: envelope, name: 'Enviar por e-mail' },
      { path: '#', image: whatsapp, name: 'Enviar por WhatsApp' },
      { path: '#', image: view, name: 'Visualizar' },
      { path: '#', image: duplicate, name: 'Duplicar' },
      { path: `/panel/fashion/edit/${orderId}`, image: pencil, name: 'Editar' },
      {
        path: '#',
        image: trash,
        name: 'Excluir',
        isDelete: true,
      },
    ];
  
    return (
      <>
        {actions.map((item, index) => (
  <ActionDiv key={index}>
    <ActionText>
      <ActionLink
        href={item.path}
        onClick={(e) => {
          e.preventDefault();
          if (item.isDelete) {
            handleDeleteOrder(orderId);
          } else if (item.path !== '#') {
            navigate(item.path);
          }
        }}
      >
        <img src={item.image} />
        {item.name}
      </ActionLink>
    </ActionText>
  </ActionDiv>
))}

      </>
    );
  };
  
  
export default Actions;